import { render, staticRenderFns } from "./pagetitle.vue?vue&type=template&id=6f0cd05e&"
import script from "./pagetitle.vue?vue&type=script&lang=js&"
export * from "./pagetitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports